(() => {
  const bound = new WeakSet();
  function bind(root = document) {
    const header = document.querySelector('.esf-header-stack');
    if (header && !bound.has(header)) {
      bound.add(header);
      new ResizeObserver(() => document.documentElement.style.setProperty('--esf-header-height', `${header.getBoundingClientRect().height}px`)).observe(header);
    }
    root.querySelectorAll('product-info, .product__info-container').forEach(info => {
      if (bound.has(info)) return;
      const button = info.querySelector('.product-form__submit');
      if (!button) return;
      bound.add(info);
      let scheduled = false;
      const update = () => {
        scheduled = false;
        if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
        const label = button.querySelector(':scope > span');
        if (!label) return;
        const checked = info.querySelector('.lumin-product-block-qty-break input[type="radio"]:checked');
        const card = checked?.closest('.lumin-product-block-qty-break');
        const price = card?.querySelector('.lumin-product-block-qty-break-total > div > span')?.textContent.trim()
          || info.querySelector('.price .price__sale .price-item--sale, .price .price__regular .price-item--regular')?.textContent.trim();
        if (!price) return;
        const text = `AJOUTER AU PANIER – ${price}`;
        if (label.textContent !== text) label.textContent = text;
      };
      const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(update); } };
      info.addEventListener('change', schedule);
      new MutationObserver(schedule).observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
      update();
    });
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => bind()) : bind();
  document.addEventListener('shopify:section:load', () => bind());
})();
